import {solicitationNote} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useSolicitationNoteStore = defineStore('solicitationNoteStore', {
  state: () => ({
    allSolicitationNote: [],
    solicitationNoteDetail: {},
    isCreateSuccess: false,
    isUpdateSuccess: false,
    loading: false,
    error: null,
  }),

  actions: {
    async getAllSolicitationNote(solicitationId) {
      this.loading = true
      try {
        const response = await solicitationNote.get(solicitationId)
        if (response.status === 200) {
          const data = response.data
          this.allSolicitationNote = data
        }
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getSolicitationNoteById(solicitationId, id) {
      this.loading = true
      try {
        const response = await solicitationNote.getById(solicitationId, id)
        if (response.status === 200) {
          const data = response.data
          this.solicitationNoteDetail = data
        }
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async addSolicitationNote(solicitationId, payload) {
      this.loading = true
      try {
        const response = await solicitationNote.create(solicitationId, payload)
        if (response.status === 201) {
          const data = response.data
          this.solicitationNoteDetail = data
          this.isCreateSuccess = true
          toast.success(successHandler('CREATE_SOLICITATION_NOTE_SUCCESS'))
        }
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async updateSolicitationNote(solicitationId, id, payload) {
      this.loading = true
      try {
        const response = await solicitationNote.update(solicitationId, id, payload)
        if (response.status === 200) {
          const data = response.data
          this.solicitationNoteDetail = data
          this.isUpdateSuccess = true
          toast.success(successHandler('UPDATE_SOLICITATION_NOTE_SUCCESS'))
        }
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async deleteSolicitationNote(solicitationId, id) {
      this.loading = true
      try {
        const response = await solicitationNote.delete(solicitationId, id)
        if (response.status === 204) {
          toast.success(successHandler('DELETE_SOLICITATION_NOTE_SUCCESS'))
        }
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },
  },
})
